import GroupProfileHeader from './GroupProfileHeader';

export default GroupProfileHeader;
